import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import flatten from 'lodash/flatten'
import DocumentTitle from 'react-document-title'
import moment from 'moment'

import Table from './OutcomeTable'
import Statistics from './Statistics'
import Action from '@components/Action'
import Add from '@components/Icon/Add'
import DownloadIcon from '@components/Icon/Download'
import Spinner from '@components/spinner'
import Tooltip from '@components/Tooltip'
import { exportDialogMessage, downloadFromUrl, tokenStorage } from '@atheneum/api/dist/lib'
import { projectApi } from '@atheneum/api'

class Outcome extends Component {
  static propTypes = {
    deliverableStore: PropTypes.object,
    projectStore: PropTypes.object,
    feeStore: PropTypes.object,
    modalStore: PropTypes.object.isRequired,
    queueProcessorStore: PropTypes.object
  }

  constructor (props) {
    super(props)
    extendObservable(this, {
      job: null,
      error: null,
      exportInProgress: false
    })
  }

  exportToExcel = async () => {
    if (this.job && this.exportInProgress) return
    const { projectStore, queueProcessorStore } = this.props
    const projectId = projectStore.project.id
    const projectName = projectStore.project.projectName

    const { jobId } = await projectApi.exportProjectDeliverables(projectId, projectName)

    const filename = `${projectName}_deliverables_${moment().format(
      'YYYYMMDD'
    )}.xlsx`

    queueProcessorStore.trackJob(jobId, ({ url }) =>
      downloadFromUrl({ url: `${url}?token=${tokenStorage.get()}`, filename })
    )

    this.job = queueProcessorStore.jobs[jobId]

    if (this.job && this.job.loading) {
      this.exportInProgress = true
      setTimeout(() => {
        this.exportInProgress = false
      }, 1000)
    }

    await exportDialogMessage({ exportType: 'project deliverables' })
  }

  changeContract = () => {
    const fees = flatten(
      this.props.deliverableStore.deliverables.map(deliverable => {
        return deliverable.fees.filter(fee => fee.checked)
      })
    )

    if (!fees.length) return

    this.props.modalStore.show({
      type: 'BATCH_CONTRACT_ASSIGN',
      props: {
        fees,
        onOk: () => {
          this.props.deliverableStore.getByProject(this.props.projectStore.id)
        }
      }
    })
  }

  render () {
    const { loading, deliverables } = this.props.deliverableStore
    if (loading) return <Spinner />

    const projectName = this.props.projectStore.project.projectName

    return (
      <DocumentTitle title={`${projectName} - outcome | Atheneum Partners`}>
        <div className='details-wrapper animate-intro'>
          <div className='pull-right'>
            <div className='actions-wrapper actions-wrapper--space-between'>
              <ul className='actions'>
                <Action
                  disabled={!deliverables.length || this.exportInProgress}
                >
                  <Tooltip
                    tooltip='There are no deliverables to export'
                    disabled={!!deliverables.length}
                  >
                    <li onClick={this.exportToExcel}>
                      <DownloadIcon />
                      <span>Export</span>
                    </li>
                  </Tooltip>
                </Action>
                <Action>
                  <li
                    data-cy='add-client-charge-btn'
                    onClick={() => this.props.feeStore.newFee()}
                  >
                    <Add />
                    <span>Add client charge</span>
                  </li>
                </Action>
                <Action>
                  <li
                    data-cy='add-cost-btn'
                    onClick={() => this.props.feeStore.newCost()}
                  >
                    <Add />
                    <span>Add cost</span>
                  </li>
                </Action>
              </ul>
            </div>
          </div>
          <div className='story'>
            <span className='label'>Project metrics</span>
            <Statistics />
          </div>

          <div className='story'>
            <span className='label'>Project deliverables</span>
            <div className='pull-right'>
              <div className='actions-wrapper actions-wrapper--space-between'>
                <ul className='actions'>
                  <Action>
                    <li onClick={() => this.changeContract()}>
                      <Add />
                      <span>Change contract</span>
                    </li>
                  </Action>
                </ul>
              </div>
            </div>
            <Table />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject(
  'queueProcessorStore',
  'deliverableStore',
  'sidebarStore',
  'projectStore',
  'feeStore',
  'modalStore'
)(observer(Outcome))
